import dayjs from 'dayjs';
import { IProduct } from 'app/shared/model/product.model';

export interface IMonthlyProductUsage {
  id?: number;
  averagePrice?: number | null;
  from?: dayjs.Dayjs | null;
  until?: dayjs.Dayjs | null;
  monthlyUsage?: number | null;
  beginStand?: dayjs.Dayjs | null;
  endStand?: dayjs.Dayjs | null;
  product?: IProduct | null;
}

export const defaultValue: Readonly<IMonthlyProductUsage> = {};
